module.exports = __webpack_public_path__ + "img/diem25-logo.cce0055f.svg";